"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactRouter = require("react-router");
var _themeProvider = require("@mmc/theme-provider");
var _modelSelector = require("@mmc/model-selector");
var _commonShareDialog = require("@mmc/common-share-dialog");
var _commonMediaQuery = require("@mmc/common-media-query");
var _text = require("@mmc/text");
var _commonLoader = require("@mmc/common-loader");
var _reactRedux = require("react-redux");
var _commonErrorMessage = require("@mmc/common-error-message");
var _reactApollo = require("react-apollo");
var utils = _interopRequireWildcard(require("./calculation-form.utils"));
var _query = require("./query");
var _calculationForm2 = require("./calculation-form.prop-types");
var _constants = require("./constants");
var _calculatorForm = _interopRequireDefault(require("./calculator-form"));
var _calculationForm3 = _interopRequireDefault(require("./calculation-form2.css"));
var _CommonLoader, _CommonLoader2, _CommonLoader3;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CalculationForm = function CalculationForm(props) {
  var _router$location$quer, _contentPageData$vehi, _tabIndexMap$LEASE$ta, _tabIndexMap$LEASE$ta2;
  var small = props.isSmallForm,
    config = props.config,
    isNgc = props.isNgc,
    inlineData = props.inlineData,
    market = props.market,
    router = props.router,
    hasLinks = props.hasLinks,
    _props$combinedStepsL = props.combinedStepsLabels,
    combinedStepsLabels = _props$combinedStepsL === void 0 ? {} : _props$combinedStepsL,
    _props$disclaimerGrou = props.disclaimerGroup,
    disclaimerGroup = _props$disclaimerGrou === void 0 ? {} : _props$disclaimerGrou,
    updatePriceHoc = props.updatePriceHoc,
    contentPageData = props.data,
    language = props.language,
    isBackgroundWhite = props.isBackgroundWhite;
  var prevValues = (0, _react.useRef)({}).current;
  var _useState = (0, _react.useState)({
      $parsed: false,
      $defaultRate: null,
      isDefaultRate: true,
      interestRate: null,
      financeTerm: null,
      financePaymentFrequency: '',
      leaseTerm: null,
      leasePaymentFrequency: '',
      leaseAnnualMileage: null,
      tradeInValue: 0,
      downPaymentAmount: null,
      includeTax: true,
      includeFee: true,
      rebates: contentPageData.defaultRebates,
      // By default these keys are diff, but after form is `dirty`,
      // they should always be the same as `downPaymentAmount` & `tradeInValue`, respectively
      financeDownPayment: 0,
      leaseDownPayment: 0,
      financeTradeInValue: 0,
      leaseTradeInValue: 0,
      cashTradeInValue: 0
    }),
    formData = _useState[0],
    setFormData = _useState[1];
  (0, _react.useEffect)(function () {
    var _ref = router.location.query || {},
      offerType = _ref.offerType;
    if (offerType) {
      var newTab = function () {
        switch (offerType.toLowerCase()) {
          case 'lease':
            return _constants.tabIndexMap.LEASE;
          case 'finance':
            return _constants.tabIndexMap.FINANCE;
          case 'cash':
            return _constants.tabIndexMap.CASH;
          default:
            return _constants.tabIndexMap.LEASE;
        }
      }();
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          selectedTab: newTab
        });
      });
    }
  }, [(_router$location$quer = router.location.query) == null ? void 0 : _router$location$quer.tab]);
  var _useState2 = (0, _react.useState)(_objectSpread(_objectSpread(_objectSpread({}, inlineData), utils.getCachedSelectModelAndTab()), {}, {
      isShareDialogOpen: false,
      selectedModel: contentPageData == null || (_contentPageData$vehi = contentPageData.vehicles) == null ? void 0 : _contentPageData$vehi[0]
    })),
    state = _useState2[0],
    setState = _useState2[1];
  var theme = (0, _themeProvider.useTheme)();
  var calculatorRef = (0, _react.useRef)();
  var cache = (0, _react.useRef)({}).current;
  var handleTabChange = function handleTabChange(selectedTab) {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      selectedTab: selectedTab
    }));
  };
  var handleFormChange = function handleFormChange(_, key, value) {
    var updatedFormData = {};
    // All the following keys need to be in `sync`
    // as they're shared across calculations
    if (utils.isDownPaymentKey(key)) {
      updatedFormData.financeDownPayment = value;
      updatedFormData.leaseDownPayment = value;
      updatedFormData.downPaymentAmount = value;
    } else if (utils.isTradeInKey(key)) {
      updatedFormData.financeTradeInValue = value;
      updatedFormData.leaseTradeInValue = value;
      updatedFormData.tradeInValue = value;
      updatedFormData.cashTradeInValue = value;
    }
    setFormData(function (prev) {
      var _objectSpread2;
      return _objectSpread(_objectSpread(_objectSpread({}, prev), updatedFormData), {}, (_objectSpread2 = {}, _objectSpread2[key] = value, _objectSpread2));
    });
  };
  var handleModelChange = function handleModelChange(selectedModelIndex, selectedModel) {
    var paymentModel = selectedModel.modelCode;
    setFormData(_objectSpread(_objectSpread({}, formData), {}, {
      paymentModel: paymentModel,
      $parsed: false
    }));
    setState(_objectSpread(_objectSpread({}, state), {}, {
      selectedModelIndex: selectedModelIndex,
      selectedModel: selectedModel
    }));
  };
  var openShareDialog = function openShareDialog() {
    if (typeof window !== 'undefined' && typeof window.navigator !== 'undefined' && window.navigator.share) {
      return window.navigator.share({
        title: cache.shareTitle,
        url: cache.shareURL
      });
    }
    (0, _themeProvider.disableBodyScroll)();
    setState(_objectSpread(_objectSpread({}, state), {}, {
      isShareDialogOpen: true
    }));
  };
  var closeShareDialog = function closeShareDialog() {
    (0, _themeProvider.enableBodyScroll)();
    setState(_objectSpread(_objectSpread({}, state), {}, {
      isShareDialogOpen: false
    }));
  };
  var location = router.location;
  var variables = utils.getQueryVariables2(location.query, _objectSpread({
    small: small,
    formData: formData,
    selectedModel: state.selectedModel
  }, props));

  // Get & parse data
  var _useQuery = (0, _reactApollo.useQuery)(_query.PC_CALCULATION_QUERY_V2, {
      variables: variables
    }),
    rawData = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  var data = utils.parseGQLData(rawData, contentPageData, formData);
  var leaseCalculation = data.leaseCalculation,
    financeCalculation = data.financeCalculation,
    cashCalculation = data.cashCalculation;
  (0, _react.useEffect)(function () {
    // Scroll up to the tab on mobile
    if (window.innerWidth <= _commonMediaQuery.BREAKPOINTS.xs.MAX && calculatorRef.current) {
      calculatorRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [state.selectedTab]);

  // Set initial values from the very first API query
  (0, _react.useEffect)(function () {
    if (rawData && !formData.$parsed) {
      var defaultRate = financeCalculation.interestRate.value;
      var updatedFormData = _objectSpread(_objectSpread({}, formData), {}, {
        $parsed: true,
        $defaultRate: defaultRate,
        financePaymentFrequency: data.financeSelectedPaymentFrequency,
        financeDownPayment: financeCalculation.downPayment.value,
        financeTradeInValue: financeCalculation.tradeInValue.value,
        leasePaymentFrequency: data.leaseSelectedPaymentFrequency,
        leaseDownPayment: leaseCalculation.downPayment.value,
        leaseTradeInValue: leaseCalculation.tradeInValue.value,
        tradeInValue: leaseCalculation.tradeInValue.value
      });
      setFormData(updatedFormData);
    }
  }, [rawData]);
  if (error) {
    return /*#__PURE__*/_react["default"].createElement(_commonErrorMessage.CommonErrorMessage, {
      theme: theme,
      errorTitle: data.dataErrorTitle,
      errorContent: data.dataErrorText,
      viewHomePage: data.viewHomePageLabel,
      viewHomePagePath: data.viewHomePagePath
    });
  }
  if (!rawData) {
    return _CommonLoader || (_CommonLoader = /*#__PURE__*/_react["default"].createElement(_commonLoader.CommonLoader, null));
  }

  // Emit updated values for OGC, NGC, etc
  var nextValues = {
    buyFor: financeCalculation.monthlyPaymentValue,
    buyPaymentFrequency: formData.financePaymentFrequency,
    buyPaymentFrequencyOptions: data.financePaymentFrequency,
    leaseFor: leaseCalculation.monthlyPaymentValue,
    leasePaymentFrequency: formData.leasePaymentFrequency,
    leasePaymentFrequencyOptions: data.leasePaymentFrequency
  };
  if (typeof updatePriceHoc === 'function' && !(0, _isEqual["default"])(prevValues, nextValues)) {
    updatePriceHoc(nextValues);
    prevValues = nextValues;
  }

  // Payment Calculator `solo` version requires vehicle selection
  if (!small && !location.query.paymentVehicle) {
    return null;
  }
  var labels = _objectSpread(_objectSpread({}, data), combinedStepsLabels.paymentCalculator);
  var disclaimerData = {
    disclaimerLabel: data.disclaimerLabel,
    disclaimerList: data.disclaimerList
  };
  var modelSelectorData = {
    vehicles: data.vehicles,
    vehicleName: data.vehicleName,
    paymentCalculatorLabel: data.paymentCalculatorLabel,
    msrpLabel: labels.msrpLabel,
    msrpDisclaimerNo: data.msrpDisclaimerNo,
    ctaText: data.ctaText,
    ctaUrl: data.ctaUrl,
    hideKeyFeatures: market === 'us'
  };
  var shareDialogInformation = {};
  var extraLinks = utils.getExtraLinks({
    small: small,
    hasLinks: hasLinks,
    isNgc: isNgc,
    data: data,
    combinedStepsLabels: combinedStepsLabels,
    calculation: {
      query: _query.PC_CALCULATION_QUERY_V2,
      type: (_tabIndexMap$LEASE$ta = {}, _tabIndexMap$LEASE$ta[_constants.tabIndexMap.LEASE] = 'Lease', _tabIndexMap$LEASE$ta[_constants.tabIndexMap.FINANCE] = 'Finance', _tabIndexMap$LEASE$ta[_constants.tabIndexMap.FINANCE] = 'Cash', _tabIndexMap$LEASE$ta)[state.selectedTab],
      calculation: (_tabIndexMap$LEASE$ta2 = {}, _tabIndexMap$LEASE$ta2[_constants.tabIndexMap.LEASE] = leaseCalculation, _tabIndexMap$LEASE$ta2[_constants.tabIndexMap.FINANCE] = financeCalculation, _tabIndexMap$LEASE$ta2[_constants.tabIndexMap.CASH] = cashCalculation, _tabIndexMap$LEASE$ta2)[state.selectedTab]
    }
  });

  // Small Payment Calculator used in Configurator tray:
  // https://us.uat.mipulse.co/en/configure-your-mitsubishi/configurator?color=W85&model=GK1WXTSUL2M-NA_A21&step=FabricSelector&trimLine=ES+1.5T+2WD&vehicle=ohiwuwrgvyma9ez12a1eq&year=2022
  if (small) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: calculatorRef,
      className: _calculationForm3["default"].fullWidth
    }, loading && (_CommonLoader2 || (_CommonLoader2 = /*#__PURE__*/_react["default"].createElement(_commonLoader.CommonLoader, null))), /*#__PURE__*/_react["default"].createElement(_calculatorForm["default"], (0, _extends2["default"])({}, config, {
      small: true,
      labels: labels,
      fullWidth: !isNgc,
      disclaimerGroup: disclaimerGroup,
      disclaimerData: disclaimerData,
      onTabChange: handleTabChange,
      onFormChange: handleFormChange,
      selectedModel: state.selectedModel,
      openShareDialog: openShareDialog,
      extraLinks: extraLinks,
      selectedTab: state.selectedTab,
      formData: formData,
      market: market,
      data: data,
      language: language,
      isBackgroundWhite: isBackgroundWhite,
      inlineData: inlineData
    })));
  }

  // Payment Calculator `solo` version
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, state.isShareDialogOpen && /*#__PURE__*/_react["default"].createElement(_commonShareDialog.CommonShareDialog, (0, _extends2["default"])({
    onClose: closeShareDialog
  }, shareDialogInformation, {
    theme: theme
  })), loading && (_CommonLoader3 || (_CommonLoader3 = /*#__PURE__*/_react["default"].createElement(_commonLoader.CommonLoader, null))), /*#__PURE__*/_react["default"].createElement(_modelSelector.ModelSelector, {
    onChange: handleModelChange,
    className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-sm-offset-1'], theme['col-sm-10'], _calculationForm3["default"].modelSelector),
    theme: theme,
    data: modelSelectorData,
    defaultModelIndex: state.selectedModelIndex,
    addPriceDisclaimer: data.msrpDisclaimerId,
    priceDisclaimerId: data.msrpDisclaimerId,
    disclaimerData: data.disclaimerData
  }), /*#__PURE__*/_react["default"].createElement("div", {
    ref: calculatorRef
  }, /*#__PURE__*/_react["default"].createElement(_calculatorForm["default"], (0, _extends2["default"])({}, config, {
    labels: labels,
    fullWidth: true,
    disclaimerGroup: disclaimerGroup,
    disclaimerData: disclaimerData,
    onTabChange: handleTabChange,
    onFormChange: handleFormChange,
    selectedTab: state.selectedTab,
    formData: formData,
    selectedModel: state.selectedModel,
    openShareDialog: openShareDialog,
    extraLinks: extraLinks,
    market: market,
    data: data
  })))));
};
CalculationForm.resourceType = function () {
  return 'PaymentCalculator_1_0_0';
};
CalculationForm.displayName = 'CalculationForm';
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language,
    path: props.path || state.Config.path,
    config: props.config || state.Config,
    globalLocation: props.globalLocation || state.globalLocation
  };
};
var _default = exports["default"] = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(CalculationForm));